<template>
  <div class="pageHolder">
    <slot v-if="pcontent !== '0'" class="fullWidth slotStyle" ></slot>
    <div v-if="pcontent === '0'" class="noContent fCol jCenter aCenter">
      <img alt="const" src="../assets/const.svg">
      <span>{{ page }} PAGE</span>
    </div>
    <div class="fCol jCenter aCenter fullWidth">
      <div v-bind:class="{
          rimikLogo: appName.name === 'rimik',
          vertaLogo: appName.name === 'verta',
          eejLogo: appName.name === 'eej',
          drsinbeLogo: appName.name === 'drsinbe',
        }"></div>
      <div class="allRights">کلیه حقوق متعلق به
        <a :href="appName.site">{{appName.faName}}</a> می‌باشد. {{date}}</div>
      <zadak row='true' dark='true' typo='true'/>
    </div>
  </div>
</template>

<script>
import Zadak from '@/components/Zadak.vue';
import Moment from 'moment-jalaali';

export default {
  name: 'dashboard-page',
  data() {
    return {
      date: '',
    };
  },
  components: {
    Zadak,
  },
  props: ['pcontent', 'page'],
  methods: {},
  computed: {
    appName() {
      return this.$store.state.appName;
    },
  },
  mounted() {
    const a = new Date();
    const b = parseInt(Moment(a).locale('fa').format('jMM'), 10);
    let season = '';
    if (b === 1 || b === 2 || b === 3) {
      season = 'بهار';
    } else if (b === 4 || b === 5 || b === 6) {
      season = 'تابستان';
    } else if (b === 7 || b === 8 || b === 9) {
      season = 'پاییز';
    } else {
      season = 'زمستان';
    }
    this.date = `${season} ${Moment(a).locale('fa').format('jYYYY')}`;
  },
  directives: {},
};
</script>

<style lang="scss" scoped>
.dashboard .pageHolder {
  position: fixed;
  top: 56px;
  left: 0;
  right: 56px;
  bottom: 0;
  padding: 32px;
  background-color: var(--themeBackground);
  overflow-x: hidden;
  overflow-y: auto;
  align-content: flex-start;
}

  .rimikLogo{
    height: 64px;
    width: 112px;
    background-position: center;
    background-size: 80%;
    background-repeat: no-repeat;
    opacity: 0.5;
    background-image: url("../assets/rimikdark.svg");
  }
  .eejLogo{
    height: 64px;
    width: 112px;
    background-position: center;
    background-size: 80%;
    background-repeat: no-repeat;
    opacity: 0.5;
    background-image: url("../assets/eejdark.svg");
  }
  .vertaLogo{
    height: 64px;
    width: 64px;
    background-position: center;
    background-size: 70%;
    background-repeat: no-repeat;
    opacity: 0.5;
    background-image: url("../assets/vertadark.svg");
  }
  .drsinbeLogo{
    height: 64px;
    width: 64px;
    background-position: center;
    background-size: 70%;
    background-repeat: no-repeat;
    opacity: 0.5;
    background-image: url("../assets/drsinbedark.svg");
  }

.pageHolder .noContent{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  user-select: none;
}

.noContent span{
  font-weight: 100;
  font-size: 32px;
  letter-spacing: 4px;
  color: rgba($color: #000000, $alpha: 0.2);
  margin-top: 24px;
}

.noContent img{
  width: 256px;
}

.allRights{
  color: var(--normalText5);
  font-size: 12px;
  font-weight: 100;
  width: 100%;
  padding: 0px 8px 16px 8px;
  user-select: none;
}

.allRights a{
  color: var(--normalText);
  font-weight: 500;
}

.simple{
  width: 80px;
  height: 80px;
  background-image: url("../assets/rimikdark.svg");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  opacity: 0.6;
}

.slotSyle{
  margin-left: auto;
  margin-right: auto;
}
</style>
